module.exports = __webpack_public_path__ + "static/media/logo-icon2.b79e7c98.svg";